'use strict';

function updateDeliveryProductLinks() {
  const requested = new URLSearchParams(window.location.search).get('size');
  const product = rooflightForSize(requested);
  if (!product) return;
  $$('[data-delivery-product]').forEach(link => { link.href = `${rooflightUrl(product)}#size-specs`; });
}

if (products.length) updateDeliveryProductLinks();
else document.addEventListener('catalogue:loaded', updateDeliveryProductLinks, { once: true });
